module.exports = __webpack_public_path__ + "static/media/2_en.93c42329.png";